require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-five-ways-to-save-money-while-youre-in-school.json") })
        }
      }, "path---blog-five-ways-to-save-money-while-youre-in-school");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-five-ways-to-save-money-while-youre-in-school!./.cache/json/blog-five-ways-to-save-money-while-youre-in-school.json
// module id = 813
// module chunks = 231608221292675